module.exports = __webpack_public_path__ + "static/media/T.9e8dbd9e.gif";